/**
 * @owner @Appboy/frontend-ix
 */

/**
 * Some imports may implicitly depend on the global window.jQuery or window.$
 * existing before they run. By importing this file they can make that
 * dependency explicit. When we have no more of those, this file can go away.
 */
import jQuery from "jquery";
(window as any).jQuery = (window as any).$ = jQuery;
export default jQuery;
